import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Partner } from "@modules/partners/types";

import { ListPartnersQueryFilters } from "./types";

export async function getPartnersService(
  filters?: ListPartnersQueryFilters
): Promise<Partner[]> {
  const { data } = await api.get<ApiResponse<Partner>>("/v1/partner_admin/", {
    params: {
      page: filters?.page,
      page_size: filters?.perPage,
      search: filters?.search,
      ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
    },
  });
  return data.results;
}
